import React from "react";
import DHSplashScreen from "../../component/DHSplashScreen";
import DefaultButton from "../../component/DefaultButton";
import Header from "../../component/Header";
import Prajavani_after_login from "../../images/prajavani-after-login.svg";
import Prajavani_logo from "../../images/prajavani-logo-img.svg";
import { PRAJAVANI_MOBILE_TAB } from "../../contant";
import Footer from "../../component/Footer";

export default function PrajavaniSuccessfulLoginPage({
  tabDetail,
  formData,
  handleInputChange,
  updateProfileMetaDataForPVUser,
  isContinueBtnDisabled,
}) {
  return (
    <div className="xxl:min-h-dvh xxxl:flex xxxl:flex-row xxxl:items-center xxxl:justify-center short-screen-spacing">
      <div className="flex flex-row w-full text-center lg:pt-8 px-10 md:p-0 md:pt-2 xxxl:pt-0 sm:min-h-mobile">
        <DHSplashScreen
          className={"div-with-bg-prajavani"}
          logoImage={Prajavani_logo}
        />
        <div className="w-1/2 shadow-md bg-white ml-2 rounded-2xl sm:w-full sm:ml-0 sm:flex sm:flex-col">
          <Header
            headerImage={Prajavani_after_login}
            className={"bg-yellow-400"}
          />
          <p className="text-gray-900 font-bold mt-[72px] mb-4 text-2xl font-notoSans sm:px-1 lg:px-1">
            ದೃಢೀಕರಣ ಯಶಸ್ವಿಯಾಗಿದೆ
          </p>
          <div className="mb-6 text-center px-5">
            {tabDetail === PRAJAVANI_MOBILE_TAB ? (
              <p className="text-gray-700 text-base mt-4 font-notoSans leading-7">
                ನಿಮ್ಮ ಮೊಬೈಲ್ ಸಂಖ್ಯೆಯನ್ನು ಯಶಸ್ವಿಯಾಗಿ ಪರಿಶೀಲಿಸಲಾಗಿದೆ
              </p>
            ) : (
              <p className="text-gray-700 text-base mt-4 font-notoSans leading-7">
                ನಿಮ್ಮ ಇಮೇಲ್ ಐಡಿಯನ್ನು ಯಶಸ್ವಿಯಾಗಿ ಪರಿಶೀಲಿಸಲಾಗಿದೆ
              </p>
            )}
          </div>
          <fieldset className="contents" disabled={isContinueBtnDisabled}>
            <form onSubmit={(e) => e.preventDefault()}>
              <div className="w-full flex justify-center mb-52">
                <div className="w-[70%] flex items-start gap-[8px] self-stretch">
                  <label
                    className="checkbox-container mt-1"
                    htmlFor="receiveMarketingAndPromitionalEmail"
                  >
                    <input
                      type="checkbox"
                      id="receiveMarketingAndPromitionalEmail"
                      name="receiveMarketingAndPromitionalEmail"
                      checked={formData.receiveMarketingAndPromitionalEmail}
                      onChange={handleInputChange}
                    />
                    <span className="checkmark"></span>
                  </label>
                  <span className="checkbox-label text-gray-700 text-sm leading-6 text-left">
                    ಮಾರುಕಟ್ಟೆ ಮತ್ತು ಪ್ರಚಾರದ ಇಮೇಲ್ ಪಡೆಯುವುದಕ್ಕೆ ನಾನು ಸಮ್ಮತಿಸುತ್ತೇನೆ.
                  </span>
                </div>
              </div>
              <div className={`drop-shadow-div mt-4`}>
                <div className="w-full mb-4 mt-4 lg:px-9 md:px-10 sm:px-10 xs:px-4">
                  <DefaultButton
                    label={"ಮುಗಿಸು"}
                    className={
                      "bg-amber-255 !text-gray-900 font-notoSans w-[55%] lg:w-full md:w-full sm:w-full xs:w-full mt-2"
                    }
                    onClick={updateProfileMetaDataForPVUser}
                    disabled={isContinueBtnDisabled}
                  />
                </div>
              </div>
            </form>
          </fieldset>
          <Footer footerLable={"ನಿಮ್ಮ ಲಾಗಿನ್, ಈಗ ಸರಳ"} className="sm:mt-auto" />
        </div>
      </div>
    </div>
  );
}
